import React from "react";
import useBreakpoints from "~/hooks/useBreakpoints";

const Logo: React.FC<{ white?: boolean }> = ({ white }) => {
  const { isMobile } = useBreakpoints();

  const type = React.useMemo(() => {
    if (white) return "mobile";

    return isMobile ? "mobile" : "desktop";
  }, [isMobile, white]);

  return (
    <a
      aria-label="Shirtspace.com Logo"
      href="/"
      className="block h-[29px] w-[150px] md:h-[38px] md:w-[200px]"
    >
      <img
        className="md:block"
        src={`/frontend-assets/images/logo_${type}.svg`}
        alt="ShirtSpace.com Logo"
      />
    </a>
  );
};

export default Logo;
